import React, { useState, useEffect } from "react";
import Navigation from "../../../components/navbar";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../../components/footer";
import ResponsiveTable from "../../../components/event-rsvp/components/event-dashboard/ResponsiveTable";
import { useGetApplicantsData } from "../../../hooks/apis/useOpenForum.api";
import RsvpSummary from "../../../components/event-rsvp/components/event-dashboard/RsvpSummary";
import { toast } from "react-toastify";
import SkeletonComponent from "../../../utils/skeleton-component/SkeletonComponent";
import WorkDeviceChart from "../../../components/event-rsvp/components/event-dashboard/WorkDevice";
import  {
  AgeLineChart,
  EducationSunburstChart,
  EmploymentRadarChart,
  GenderDonutCharts,
} from "../../../components/event-rsvp/components/event-dashboard/StatisticalData";





const AdminEventRsvp = () => {
  const { data, status, error, isFetching  } = useGetApplicantsData();
  const [title] = useState("Open Forum RSVP | Eraconneckt");

  useEffect(() => {
    if (status === "error") {
      toast.error(error?.response?.data?.error || "Failed to fetch RSVP data.");
      console.error(error?.message);
    }
  }, [status, error, data]);

  useEffect(() => {
    // This will run when the page first loads and whenever the title changes
    document.title = title;
  }, [title]);

  return (
    <>
      <Navigation />
      <Container>
        <>
          {(status === "pending" || isFetching) ? (
            <SkeletonComponent count={24} />
          ) : (
            <>
              <Row style={{ marginTop: "100px" }}>
                <RsvpSummary data={data || []} />
              </Row>
              <Row style={{ marginTop: "100px" }}>
                <WorkDeviceChart data={data?.data || []} />
              </Row>
              <Row style={{ marginTop: "100px" }}>
                <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }}>
                  <GenderDonutCharts data={data?.data || []} />
                </Col>

                <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 2 }}>
                  <AgeLineChart data={data?.data || []} />
                </Col>
              </Row>
              <Row style={{ marginTop: "100px" }}>
                <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }}>
                  <EducationSunburstChart data={data?.data || []} />
                </Col>
                <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 2 }}>
                  <EmploymentRadarChart data={data?.data || []} />
                </Col>{" "}
              </Row>

              <Row>
                <ResponsiveTable data={data?.data || []} />
              </Row>
            </>
          )}
        </>
      </Container>
      <Footer />
    </>
  );
};

export default AdminEventRsvp;
